import SvgIcon from '@mui/material/SvgIcon';

export default function ArrowDropDownIcon(props) {
  return (
    <SvgIcon {...props}>
      <path fill="currentColor" d="M7.83301 10.9167L11.9997 15.0833L16.1663 10.9167H7.83301Z" />
    </SvgIcon>
  );
}